import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class StringUtility {
  public makeCapitalizeEachStringInStringArray(stringArray: string[]): string[] {
    const finalString = stringArray.map((a) => a.charAt(0).toUpperCase() + a.substr(1));
    return finalString;
  }
}
